<template>
    <o-form-group
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <b-input-group v-if="!is_overriding">
            <template v-slot:append>
                <b-button @click="override" variant="outline-secondary">
                    <lock-icon />
                </b-button>
            </template>

            <b-form-input
                :class="input_class"
                @click="override"
                class="readonly_field"
                disabled
                type="number"
                v-bind="$attrs"
                v-bind:value="originalValue"
                v-on="inputListeners"
            >
                <slot />
            </b-form-input>
        </b-input-group>

        <b-input-group v-if="is_overriding">
            <b-form-input
                :class="input_class"
                :disabled="_is_readonly"
                type="number"
                v-bind="$attrs"
                v-bind:value="value"
                v-on="inputListeners"
            >
                <slot />
            </b-form-input>

            <template v-slot:append>
                <b-button
                    :disabled="_is_readonly"
                    @click="unoverride"
                    variant="info"
                >
                    <lock-open-variant-outline-icon />
                </b-button>
            </template>
        </b-input-group>

        <span v-if="formState.debug">
            SE:{{ serverErrors }} [{{ serverErrorsIndex }}].{{ name }}<br />
            AL_SE:{{ all_server_errors }}
        </span>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";

import LockIcon from "vue-material-design-icons/Lock";
import LockOpenVariantOutlineIcon from "vue-material-design-icons/LockOpenVariantOutline";

import OFormGroup from "../OFormGroup";

export default {
    name: "OOverridableNumberField",
    components: { OFormGroup, LockIcon, LockOpenVariantOutlineIcon },
    mixins: [FormComponentMixin],
    data() {
        return {
            pressed_override: false,
        };
    },
    props: {
        /* NOTE maybe a string because it's JSON was a string from server */
        originalValue: { type: [Number, String], default: null },
    },
    methods: {
        override() {
            this.pressed_override = true;
            // WE are overriding this now.
            this.on_input(parseFloat(this.originalValue));
        },
        unoverride() {
            this.pressed_override = false;

            this.on_input(null);
        },
    },
    computed: {
        is_overriding() {
            if (this.pressed_override) {
                return true;
            }

            return this.value != null;
        },
    },
};
</script>

<style scoped></style>
